var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", {
    staticClass: "echart_content",
    attrs: { id: "couponEchartContent" },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }